// Import dashboard charts
import { setupDashboardCharts } from './dashboard_charts'

// Dashboard filter functionality with Turbo Frame updates
export function initializeDashboardFilters() {
  // Check if we're on the dashboard page for initialization
  
  // Get all DOM elements once
  const prevWeekButton = document.getElementById('prev-week');
  const nextWeekButton = document.getElementById('next-week');
  const startDateInput = document.getElementById('start-datepicker');
  const endDateInput = document.getElementById('end-datepicker');
  const quickFilterButton = document.getElementById('quick-filter-button');
  const quickFilterDropdown = document.getElementById('quick-filter-dropdown');
  const quickFilterOptions = document.querySelectorAll('.quick-filter-option');
  const applyFilterButton = document.getElementById('apply-filter');

  // Initialize Flowbite Date Pickers
  let startDatePicker, endDatePicker;
  
  // Helper function to update tooltips when dates change
  function updateTooltipsOnDateChange() {
    if (startDateInput.value && endDateInput.value) {
      const start = new Date(startDateInput.value + 'T00:00:00');
      const end = new Date(endDateInput.value + 'T00:00:00');
      const duration = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;
      window.updateNavigationButtons(duration, startDateInput.value, endDateInput.value);
    }
  }

  // Initialize Flowbite date pickers if available
  try {
    if (startDateInput && typeof window.Datepicker !== 'undefined') {
      startDatePicker = new window.Datepicker(startDateInput, {
        format: 'yyyy-mm-dd',
        autohide: true,
        todayBtn: true,
        clearBtn: true,
        todayBtnMode: 1,
        todayHighlight: true,
        weekStart: 0,
        orientation: 'bottom auto'
      });
      
      startDateInput.addEventListener('changeDate', function() {
        updateTooltipsOnDateChange();
        setTimeout(() => startDatePicker.hide(), 100);
      });
    } else if (startDateInput) {
      startDateInput.removeAttribute('readonly');
      startDateInput.type = 'date';
    }
    
    if (endDateInput && typeof window.Datepicker !== 'undefined') {
      endDatePicker = new window.Datepicker(endDateInput, {
        format: 'yyyy-mm-dd',
        autohide: true,
        todayBtn: true,
        clearBtn: true,
        todayBtnMode: 1,
        todayHighlight: true,
        weekStart: 0,
        orientation: 'bottom auto'
      });
      
      endDateInput.addEventListener('changeDate', function() {
        updateTooltipsOnDateChange();
        setTimeout(() => endDatePicker.hide(), 100);
      });
    } else if (endDateInput) {
      endDateInput.removeAttribute('readonly');
      endDateInput.type = 'date';
    }
  } catch (error) {
    console.warn('Error initializing Flowbite date pickers:', error);
    if (startDateInput) {
      startDateInput.removeAttribute('readonly');
      startDateInput.type = 'date';
    }
    if (endDateInput) {
      endDateInput.removeAttribute('readonly');
      endDateInput.type = 'date';
    }
  }
  
  window.startDatePicker = startDatePicker;
  window.endDatePicker = endDatePicker;

  // Navigation functionality with debouncing
  if (typeof window.navigationInProgress === 'undefined') {
    window.navigationInProgress = false;
  }
  
  if (prevWeekButton && !prevWeekButton.hasAttribute('data-listener-attached')) {
    prevWeekButton.setAttribute('data-listener-attached', 'true');
    prevWeekButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!window.navigationInProgress) {
        window.navigationInProgress = true;
        navigateDateRange(-1);
      }
    });
  }

  if (nextWeekButton && !nextWeekButton.hasAttribute('data-listener-attached')) {
    nextWeekButton.setAttribute('data-listener-attached', 'true');
    nextWeekButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!window.navigationInProgress) {
        window.navigationInProgress = true;
        navigateDateRange(1);
      }
    });
  }

  function navigateDateRange(direction) {
    const startDate = startDateInput.value;
    const endDate = endDateInput.value;
    
    if (!startDate || !endDate) {
      console.error('Start date and end date are required for navigation');
      window.navigationInProgress = false;
      return;
    }
    
    const start = new Date(startDate + 'T00:00:00');
    const end = new Date(endDate + 'T00:00:00');
    
    function isLastDayOfMonth(date) {
      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return date.getDate() === lastDay.getDate();
    }
    
    const isMonthlyRange = start.getDate() === 1 && isLastDayOfMonth(end);
    
    let newStart, newEnd, durationDays;
    
    if (isMonthlyRange) {
      if (direction > 0) {
        newStart = new Date(start.getFullYear(), start.getMonth() + 1, 1);
      } else {
        newStart = new Date(start.getFullYear(), start.getMonth() - 1, 1);
      }
      newEnd = new Date(newStart.getFullYear(), newStart.getMonth() + 1, 0);
      const newDurationMs = newEnd - newStart;
      durationDays = Math.round(newDurationMs / (1000 * 60 * 60 * 24)) + 1;
    } else {
      const durationMs = end - start;
      durationDays = Math.round(durationMs / (1000 * 60 * 60 * 24)) + 1;
      
      if (direction > 0) {
        newStart = new Date(end);
        newStart.setDate(end.getDate() + 1);
      } else {
        newStart = new Date(start);
        newStart.setDate(start.getDate() - durationDays);
      }
      
      newEnd = new Date(newStart);
      newEnd.setDate(newStart.getDate() + (durationDays - 1));
    }
    
    function formatDateForInput(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }
    
    if (window.startDatePicker && window.endDatePicker) {
      window.startDatePicker.setDate(newStart);
      window.endDatePicker.setDate(newEnd);
    } else {
      startDateInput.value = formatDateForInput(newStart);
      endDateInput.value = formatDateForInput(newEnd);
    }
    
    window.updateNavigationButtons(durationDays, formatDateForInput(newStart), formatDateForInput(newEnd));
    
    if (quickFilterButton) {
      quickFilterButton.innerHTML = `
        <svg class="w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z"/>
        </svg>
        Custom Range
        <svg class="w-2.5 h-2.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
        </svg>
      `;
    }
    
    setTimeout(function() {
      applyDateRangeFilter();
    }, 100);
    
    // Reset navigation flag after a shorter delay
    setTimeout(function() {
      window.navigationInProgress = false;
    }, 500);
  }

  // Make updateNavigationButtons globally accessible
  window.updateNavigationButtons = function(durationDays, startDate = null, endDate = null) {
    let prevTitle, nextTitle;
    
    if (startDate && endDate) {
      const start = new Date(startDate + 'T00:00:00');
      const end = new Date(endDate + 'T00:00:00');
      
      function isLastDayOfMonth(date) {
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return date.getDate() === lastDay.getDate();
      }
      
      const isMonthlyRange = start.getDate() === 1 && isLastDayOfMonth(end);
      
      if (isMonthlyRange) {
        prevTitle = "Previous Month";
        nextTitle = "Next Month";
      } else if (durationDays === 7) {
        prevTitle = "Previous Week";
        nextTitle = "Next Week";
      } else if (durationDays === 1) {
        prevTitle = "Previous Day";
        nextTitle = "Next Day";
      } else {
        prevTitle = `Previous ${durationDays} Days`;
        nextTitle = `Next ${durationDays} Days`;
      }
    } else {
      if (durationDays === 7) {
        prevTitle = "Previous Week";
        nextTitle = "Next Week";
      } else if (durationDays >= 28 && durationDays <= 31) {
        prevTitle = "Previous Month";
        nextTitle = "Next Month";
      } else if (durationDays === 1) {
        prevTitle = "Previous Day";
        nextTitle = "Next Day";
      } else {
        prevTitle = `Previous ${durationDays} Days`;
        nextTitle = `Next ${durationDays} Days`;
      }
    }
    
    if (prevWeekButton) prevWeekButton.setAttribute('title', prevTitle);
    if (nextWeekButton) nextWeekButton.setAttribute('title', nextTitle);
  }

  if (startDateInput && endDateInput && startDateInput.value && endDateInput.value) {
    const start = new Date(startDateInput.value + 'T00:00:00');
    const end = new Date(endDateInput.value + 'T00:00:00');
    const duration = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;
    window.updateNavigationButtons(duration, startDateInput.value, endDateInput.value);
  }
  
  // Quick filter dropdown functionality
  if (quickFilterButton && !quickFilterButton.hasAttribute('data-listener-attached')) {
    quickFilterButton.setAttribute('data-listener-attached', 'true');
    quickFilterButton.addEventListener('click', function() {
      quickFilterDropdown.classList.toggle('hidden');
    });
  }

  // Add global click listener only once
  if (!document.body.hasAttribute('data-global-click-listener')) {
    document.body.setAttribute('data-global-click-listener', 'true');
    document.addEventListener('click', function(event) {
      const quickFilterButton = document.getElementById('quick-filter-button');
      const quickFilterDropdown = document.getElementById('quick-filter-dropdown');
      if (quickFilterButton && quickFilterDropdown) {
        if (!quickFilterButton.contains(event.target) && !quickFilterDropdown.contains(event.target)) {
          quickFilterDropdown.classList.add('hidden');
        }
      }
    });
  }

  quickFilterOptions.forEach(option => {
    if (!option.hasAttribute('data-listener-attached')) {
      option.setAttribute('data-listener-attached', 'true');
      option.addEventListener('click', function(e) {
        e.preventDefault();
        const period = this.getAttribute('data-period');
        
        const quickFilterButton = document.getElementById('quick-filter-button');
        const quickFilterDropdown = document.getElementById('quick-filter-dropdown');
        
        if (quickFilterButton) {
          quickFilterButton.innerHTML = `
            <svg class="w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z"/>
            </svg>
            ${this.textContent}
            <svg class="w-2.5 h-2.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 4 4 4-4"/>
            </svg>
          `;
        }
        
        if (quickFilterDropdown) {
          quickFilterDropdown.classList.add('hidden');
        }
        
        applyQuickFilter(period);
      });
    }
  });

  if (applyFilterButton && !applyFilterButton.hasAttribute('data-listener-attached')) {
    applyFilterButton.setAttribute('data-listener-attached', 'true');
    applyFilterButton.addEventListener('click', function() {
      applyDateRangeFilter();
    });
  }

  [startDateInput, endDateInput].forEach(input => {
    if (input && !input.hasAttribute('data-listener-attached')) {
      input.setAttribute('data-listener-attached', 'true');
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          applyDateRangeFilter();
        }
      });
      
      input.addEventListener('blur', function() {
        updateTooltipsOnDateChange();
      });
    }
  });

  // Global keyboard shortcuts for navigation
  if (!document.body.hasAttribute('data-keyboard-shortcuts-attached')) {
    document.body.setAttribute('data-keyboard-shortcuts-attached', 'true');
    document.addEventListener('keydown', function(e) {
      if (e.target.tagName.toLowerCase() === 'input' || e.target.tagName.toLowerCase() === 'textarea') {
        return;
      }
      
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        const prevButton = document.getElementById('prev-week');
        if (prevButton && !window.navigationInProgress) {
          prevButton.click();
        }
      }
      
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        const nextButton = document.getElementById('next-week');
        if (nextButton && !window.navigationInProgress) {
          nextButton.click();
        }
      }
    });
  }
}

// Turbo Frame filter functions
export function applyQuickFilter(period) {
  console.log('Applying quick filter:', period);
  
  const url = new URL(window.location);
  url.searchParams.set('quick_filter', period);
  url.searchParams.delete('start_date');
  url.searchParams.delete('end_date');
  
  console.log('Updating dashboard stats via Turbo Frame:', url.toString());
  
  // Use Turbo Frame to update just the dashboard stats
  const frame = document.getElementById('dashboard_stats');
  if (frame) {
    frame.src = url.toString();
  }
}

export function applyDateRangeFilter() {
  const startDate = document.getElementById('start-datepicker').value;
  const endDate = document.getElementById('end-datepicker').value;
  
  console.log('Applying filter with dates:', startDate, 'to', endDate);
  
  if (!startDate || !endDate) {
    alert('Please select both start and end dates');
    return;
  }
  
  const start = new Date(startDate + 'T00:00:00');
  const end = new Date(endDate + 'T00:00:00');
  
  if (start > end) {
    alert('Start date must be before end date');
    return;
  }
  
  const daysDiff = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;
  if (daysDiff > 365) {
    alert('Date range cannot exceed 365 days');
    return;
  }
  
  const url = new URL(window.location);
  url.searchParams.set('start_date', startDate);
  url.searchParams.set('end_date', endDate);
  url.searchParams.delete('quick_filter');
  
  console.log('Updating dashboard stats via Turbo Frame:', url.toString());
  
  // Use Turbo Frame to update just the dashboard stats
  const frame = document.getElementById('dashboard_stats');
  if (frame) {
    frame.src = url.toString();
  }
}

// Function to sync date inputs with dates from the loaded frame
export function syncDateInputsFromFrame() {
  const dateSyncElement = document.getElementById('dashboard-date-sync');
  const startDateInput = document.getElementById('start-datepicker');
  const endDateInput = document.getElementById('end-datepicker');
  
  if (dateSyncElement && startDateInput && endDateInput) {
    const startDate = dateSyncElement.getAttribute('data-start-date');
    const endDate = dateSyncElement.getAttribute('data-end-date');
    
    if (startDate && endDate) {
      console.log('Syncing date inputs:', startDate, 'to', endDate);
      
      // Update date inputs
      startDateInput.value = startDate;
      endDateInput.value = endDate;
      
      // Update Flowbite date pickers if they exist
      if (window.startDatePicker && window.endDatePicker) {
        window.startDatePicker.setDate(new Date(startDate + 'T00:00:00'));
        window.endDatePicker.setDate(new Date(endDate + 'T00:00:00'));
      }
      
      // Update navigation button tooltips
      const start = new Date(startDate + 'T00:00:00');
      const end = new Date(endDate + 'T00:00:00');
      const duration = Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1;
      window.updateNavigationButtons(duration, startDate, endDate);
    }
  }
}

// Initialize dashboard filters and set up event listeners
export function setupDashboard() {
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    window.navigationInProgress = false;
    initializeDashboardFilters();
    setupDashboardCharts();
  });

  // Handle Turbo navigation
  document.addEventListener('turbo:load', function() {
    window.navigationInProgress = false;
    initializeDashboardFilters();
    setupDashboardCharts();
  });

  // Reset navigation flag when Turbo Frame finishes loading
  document.addEventListener('turbo:frame-load', function(event) {
    if (event.target.id === 'dashboard_stats') {
      console.log('Dashboard stats frame loaded - resetting navigation flag');
      window.navigationInProgress = false;
      
      // Sync date inputs with server-calculated dates
      syncDateInputsFromFrame();
      
      // Reinitialize charts when dashboard stats frame loads
      setupDashboardCharts();
    }
  });
} 